import React, { Component } from 'react';
import { Button, IconButton, TableBody, TableCell, withStyles } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
// import Program from './Program';
import Table from '@material-ui/core/Table';
import TableRow from '@material-ui/core/TableRow';

const styles = (theme) => ({
  dialogRoot: {
    minHeight: '80vh',
    maxHeight: '92vh',
    [theme.breakpoints.down('sm')]: {
      maxHeight: '100vh',
      margin: '0px',
    },
  },
  dialogTitle: {
    margin: '0',
    padding: '8px 8px 0',
    fontSize: '20px',
    color: theme.palette.primary.main,
    textAlign: 'center',
    borderBottom: '0px',
  },
  dialogTitleContent: {
    fontWeight: 'bold',
    margin: '0 15px',
    textAlign: 'left',
    paddingTop: '1em',
    paddingBottom: '1.5em',
    [theme.breakpoints.down('sm')]: {
      padding: '0.6em',
      fontSize: '16px',
    },
  },
  dialogContent: {
    marginBottom: '10px',
    [theme.breakpoints.down('sm')]: {
      padding: '8px',
    },
  },
  dialogActions: {
    borderTop: '1px solid #ebebeb',
    margin: '0 24px',
    textAlign: 'center',
    display: 'none',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      display: 'block',
    },
  },
  contents: {
    padding: theme.spacing(1),
  },
  msgImg: {
    width: '100%',
    height: 'auto',
  },
  tableHead: {
    background: '#f3f3f3',
    width: '160px',
    borderTop: '1px solid #e0e0e0',
    borderLeftWidth: '0px',
    borderRightWidth: '0px',

    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  tableContent: {
    borderLeftWidth: '0px',
    borderRightWidth: '0px',
    width: '20%',
    marginRight: '2px',
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  cell2: {
    borderBottom: 0,
  },
});

class ProgramDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { classes, open, onClose, disableBackdrop } = this.props;
    console.log(this.props.selData);

    return (
      <div>
        <Dialog
          fullWidth={true}
          maxWidth={'md'}
          onClose={onClose}
          aria-labelledby="welcome-msg-dialog"
          open={open}
          disableBackdropClick={disableBackdrop}
          disableEscapeKeyDown={disableBackdrop}
          className={classes.dialogRoot}
        >
          <DialogTitle className={classes.dialogTitle} onClose={onClose}>
            {this.props.selData ? (
              <>
                <div className={classes.dialogTitleContent}>
                  [{`${this.props.selData.ch}`}] {this.props.selData.pgTitle}
                  <div>
                    <p>{this.props.selData.dpTime}</p>
                  </div>
                </div>
              </>
            ) : (
              ''
            )}
            <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent className={classes.dialogContent}>
            <Table size="small" className={classes.table}>
              <TableBody>
                {this.props.data.map((d, idx) => {
                  const check =
                    d.title === 'Moderator' || d.title === 'Facilitator' || d.title === 'Panel' || d.title === 'Live Chat Panel';
                  if (d.presenter.indexOf('^') !== -1) {
                    const arrPre = d.presenter.split('^');
                    return arrPre.map((pre, j) => {
                      return (
                        <TableRow key={j}>
                          {j === 0 ? (
                            <TableCell rowSpan={arrPre.length} style={{ fontWeight: 'bold' }}>
                              {d.title}
                            </TableCell>
                          ) : null}
                          {check ? null : <TableCell style={j < arrPre.length - 1 ? { borderBottom: '0px' } : {}}>{d.contents}</TableCell>}
                          <TableCell
                            colSpan={check ? 2 : 0}
                            align={check ? 'left' : 'right'}
                            padding={'none'}
                            style={j < arrPre.length - 1 ? { borderBottom: '0px', paddingLeft: '16px' } : { paddingLeft: '16px' }}
                          >
                            {arrPre[j]}
                          </TableCell>
                        </TableRow>
                      );
                    });
                  } else {
                    return (
                      <TableRow key={idx}>
                        <TableCell style={{ fontWeight: 'bold' }}>
                          {d.order === '99' ? 'All' : d.order === '0' || d.order === 0 ? 'Moderator(s)' : 'Speaker'}
                        </TableCell>
                        <TableCell>{d.title}</TableCell>
                        {check ? null : <TableCell style={{ fontWeight: 'bold' }}>{d.contents}</TableCell>}
                        <TableCell colSpan={check ? 2 : 0} align={check ? 'left' : 'right'}>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: `${d.presenter.replace('(', '<br/>(')}`,
                            }}
                          />
                        </TableCell>
                      </TableRow>
                    );
                  }
                })}
              </TableBody>
            </Table>
          </DialogContent>
          <DialogActions className={classes.dialogActions}>
            <Button onClick={onClose} disableElevation style={{ color: '#000000', fontSize: '18px', fontWeight: '600' }}>
              닫기
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default withStyles(styles)(ProgramDialog);
